// Colours
import { emeraldGreen, grey, hoverGrey } from "Constants/ColourConstants";

const baseButton = {
  minWidth: "fit-content",
  borderRadius: "2rem",
  gap: "0.5rem",
  justifyContent: "center",
  paddingX: "0.5rem",
};

export const styles = {
  backButton: {
    ...baseButton,
    backgroundColor: "secondary.main",
  },
  greenActionButton: {
    ...baseButton,
    backgroundColor: "primary.main",
    color: "background.paper",
  },
  outlineGreenActionButton: {
    ...baseButton,
    backgroundColor: "background.paper",
    color: "primary.main",
    border: `1px solid`,
    borderColor: "primary.main",
    "&:hover": { backgroundColor: "action.hover" },
  },
  outlineGreyActionButton: {
    ...baseButton,
    color: grey,
    border: `1px solid ${grey}`,
    "&:hover": {
      backgroundColor: hoverGrey,
    },
  },
  cancelButton: {
    p: 1,
    color: emeraldGreen,
    textDecoration: "underline",
    whiteSpace: "nowrap",
  },
};
